import type { AxiosResponse } from "axios"

import { apiClient } from "../../lib/axios"
import type { FeedbackCountInsight } from "../../types/generated/api/FeedbackCountInsight"
import type { FeedbackPerLabelAndReason } from "../../types/generated/api/FeedbackPerLabelAndReason"
import type { LabelInsight } from "../../types/generated/api/LabelInsight"
import type { LabelReasonsInsight } from "../../types/generated/api/LabelReasonsInsight"
import { getHostnames } from "../../utils/genericHelpers"

const { backend } = getHostnames()

export const RealTimeInsightsAPI = {
  fetchFeedbackCount: async (props: {
    project_uuid: string
    start_time: string
    end_time: string
  }): Promise<AxiosResponse<FeedbackCountInsight>> => {
    const { end_time, project_uuid, start_time } = props

    return await apiClient.fetchResource(backend, `/projects/${project_uuid}/feedback-counts-insight/`, {
      start_time,
      end_time,
    })
  },
  fetchFeedbackPerLabelAndReason: async (props: {
    project_uuid: string
    start_time: string
    end_time: string
  }): Promise<AxiosResponse<FeedbackPerLabelAndReason>> => {
    const { end_time, project_uuid, start_time } = props

    return await apiClient.fetchResource(backend, `/projects/${project_uuid}/feedback-per-label-and-reason-insight/`, {
      start_time,
      end_time,
    })
  },
  fetchLabelInsight: async (props: {
    project_uuid: string
    start_time: string
    end_time: string
  }): Promise<AxiosResponse<LabelInsight>> => {
    const { end_time, project_uuid, start_time } = props

    return await apiClient.fetchResource(backend, `/projects/${project_uuid}/label-insight/`, {
      start_time,
      end_time,
    })
  },
  fetchLabelReasonInsight: async (props: {
    project_uuid: string
    start_time: string
    end_time: string
  }): Promise<AxiosResponse<LabelReasonsInsight>> => {
    const { end_time, project_uuid, start_time } = props

    return await apiClient.fetchResource(backend, `/projects/${project_uuid}/label-reason-insight/`, {
      start_time,
      end_time,
    })
  },
}
